import { OpportunitySchema } from '@features/opportunities/modules/core/models/schema-property-definition';

export namespace Contact {
  export interface SchemaPropertyDefinition {
    email: OpportunitySchema.StringPropertyDefinition;
    homePhone: OpportunitySchema.StringPropertyDefinition;
    mobile: OpportunitySchema.StringPropertyDefinition;
    workPhone: OpportunitySchema.StringPropertyDefinition;
    preferredMethod: OpportunitySchema.OptionsPropertyDefinition;
  }

  export interface SchemaContract {
    email?: string | null;
    homePhone?: string | null;
    mobile?: string | null;
    workPhone?: string | null;
    preferredMethod?: string | null;
  }

  export interface Model {
    email: string | null;
    homePhone: string | null;
    mobile: string | null;
    workPhone: string | null;
    preferredMethod: string | null;
  }

  export function toModel(contract: SchemaContract): Model {
    return {
      email: contract.email ?? null,
      homePhone: contract.homePhone ?? null,
      mobile: contract.mobile ?? null,
      workPhone: contract.workPhone ?? null,
      preferredMethod: contract.preferredMethod ?? null
    };
  }

  export function toSchemaContract(
    model: Partial<Model>
  ): Partial<SchemaContract> {
    return model as Partial<SchemaContract>;
  }
}
